import {EndpointEnum} from "../../constants/EndpointEnum";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import IStore from "../../models/IStore";
import * as EffectUtility from '../../utilities/EffectUtility';



export default class InitBackendEffect {
    public static async getInitEffect(state: IStore):Promise<String | HttpErrorResponseModel> {
        return await EffectUtility.getToModelNoAuth<String>(state, String, EndpointEnum.initBackendRequest);
    }
}